import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ContainersService } from '@services/containers/containers.service';

export interface DialogData {
  idContainer: string;
}

@Component({
  selector: 'app-opendialog-delete-container',
  templateUrl: './opendialog-delete-container.component.html',
  styleUrls: ['./opendialog-delete-container.component.scss']
})
export class OpendialogDeleteContainerComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<OpendialogDeleteContainerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private containersService: ContainersService
  ) { }

  ngOnInit(): void {
  }

  deleteContainer(): void {
    this.containersService.deleteContainer(this.data.idContainer).subscribe(() => {
      // this.router.navigate(['/containers']);
      this.dialogRef.close();
    });
  }

}
